import React from "react";
import UserProfileDetailsRegular from "./UserProfileDetailsRegular";
import UserProfileDetailsFUHSD from "./UserProfileDetailsFUHSD";

export default function UserProfileDetails(props) {
  const { parsedUserProfile } = props;

  // Check if the user is affiliated with FUHSD
  const isFUHSD = parsedUserProfile?.affiliation === "FUHSD";

  // Render the appropriate component based on affiliation
  if (isFUHSD) {
    return <UserProfileDetailsFUHSD {...props} />;
  }

  return <UserProfileDetailsRegular {...props} />;
}
